"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.datesInRange = exports.isDateInRange = void 0;
const _ = __importStar(require("lodash"));
/**
 * Evaluates if a date is within a range. Defaults to inclusive of start and end dates.
 *
 * @param inclusive defines if both start and end dates are inclusive, not to be used with startInclusive or endInclusive
 * @param startInclusive defines if start date is inclusive, can be used in tandem with endInclusive
 * @param endInclusive defines if end date is inclusive, can be used in tandem with startInclusive
 */
const isDateInRange = ({ start, end, date, inclusive, startInclusive, endInclusive, }) => {
    const greaterThanStart = date > start;
    const greaterThanAndEqualToStart = date >= start;
    const lessThanEnd = date < end;
    const lessThanAndEqualToEnd = date <= end;
    // if all 3 undefined, default to inclusive
    if (_.isNil(inclusive) && _.isNil(startInclusive) && _.isNil(endInclusive)) {
        // eslint-disable-next-line no-param-reassign
        inclusive = true;
    }
    else if (_.isNil(inclusive)) {
        // if inclusive not defined, then default undfined start and end inclusive to true
        if (_.isNil(startInclusive)) {
            // eslint-disable-next-line no-param-reassign
            startInclusive = true;
        }
        if (_.isNil(endInclusive)) {
            // eslint-disable-next-line no-param-reassign
            endInclusive = true;
        }
    }
    if (inclusive === true) {
        return greaterThanAndEqualToStart && lessThanAndEqualToEnd;
    }
    if (startInclusive && endInclusive) {
        return greaterThanAndEqualToStart && lessThanAndEqualToEnd;
    }
    if (!startInclusive && endInclusive) {
        return greaterThanStart && lessThanAndEqualToEnd;
    }
    if (startInclusive && !endInclusive) {
        return greaterThanAndEqualToStart && lessThanEnd;
    }
    return greaterThanStart && lessThanEnd;
};
exports.isDateInRange = isDateInRange;
/**
 * Returns a filtered list of dates that are within a range. Defaults to inclusive of start and end dates.
 *
 * @param inclusive defines if both start and end dates are inclusive, not to be used with startInclusive or endInclusive
 * @param startInclusive defines if start date is inclusive, can be used in tandem with endInclusive
 * @param endInclusive defines if end date is inclusive, can be used in tandem with startInclusive
 */
const datesInRange = ({ start, end, dates, inclusive, startInclusive, endInclusive, }) => {
    const isDateInRangeEvaluator = (date) => {
        if (_.isBoolean(inclusive)) {
            return (0, exports.isDateInRange)({
                start,
                end,
                date,
                inclusive,
            });
        }
        return (0, exports.isDateInRange)({ start, end, date, startInclusive, endInclusive });
    };
    return dates.filter(isDateInRangeEvaluator);
};
exports.datesInRange = datesInRange;
//# sourceMappingURL=range.js.map